<template>
    <div class="tour-blase">
        <p>{{ tourStep.label }}</p>
        <div class="knoepfe">
            <button class="weiter" @click="$emit('skip')">Weiter</button>
            <button class="schliessen" @click="$emit('close')">Schliessen</button>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        tourStep: Object
    }
}

</script>

<style scoped>
.tour-blase {
    position: relative;
    z-index: 102; /* above the tour overlay (100) and the lifted target (101) */
    max-width: 220px;
    padding: 0.85rem 1rem 0.75rem;
    background: #ffffff;
    border-radius: var(--zs-ecke);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.25);
    text-align: left;
}

p {
    margin: 0 0 0.6rem;
    font-size: 1rem;
    line-height: 1.5;
    color: var(--zs-tinte);
}

.knoepfe {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

button {
    min-height: 2.25rem;
    padding: 0.45rem 0.95rem;
    font: inherit;
    font-size: 0.95rem;
    border-radius: var(--zs-ecke);
    cursor: pointer;
}

.weiter {
    font-weight: 500;
    color: #ffffff;
    background: var(--zs-blau);
    border: 1px solid var(--zs-blau);
}

.schliessen {
    margin-left: auto;
    padding-inline: 0.5rem;
    color: var(--zs-grau);
    background: transparent;
    border: none;
}

.schliessen:hover {
    color: var(--zs-tinte);
    text-decoration: underline;
    text-underline-offset: 3px;
}

button:focus-visible {
    outline: 3px solid var(--zs-orange);
    outline-offset: 2px;
}
</style>
